import NumberField from '../../NumberFields/NumberFields';
import styles from '../../SizeAndWeightStyles.module.css';

const GroupSubTotals = ({
  leftSubtotal = "",
  rightSubtotal = "",
  subtotal = "",
  overLimit = ""
}) => {
  return (
    <div id="group-total-container" className={`${styles['flexColumn']} ${styles['fullWidth']} ${styles['flexAlignEnd']}`}>
      <div className={`${styles['flexRow']} ${styles['fullWidth']} ${styles['flexStart']}`}>
        <NumberField
          value={leftSubtotal}
          id={"group-sub-total-left-subtotal"}
          label={"Left Subtotal"}
          lbs={true}
          disabled={true}
          bold={true}
        />
        <NumberField
          value={rightSubtotal}
          id={"group-sub-total-right-subtotal"}
          label={"Right Subtotal"}
          lbs={true}
          disabled={true}
          bold={true}
        />
        <NumberField
          value={subtotal}
          id={"group-sub-total-subtotal"}
          label={"Subtotal"}
          lbs={true}
          disabled={true}
          bold={true}
        />
      </div>
      <NumberField
        value={overLimit}
        label={`${overLimit > 0 ? "Over" : "Under"} Limit`}
        id="group-sub-total-difference"
        lbs={true}
        bold={true}
        disabled={true}
        showColor={true}
      />
    </div>
  )
}

export default GroupSubTotals;